<template>
  <mtd-modal
    v-model="reportInfoVisible"
    :title="
      $getText('O_Integrity_reporting_ChsK', { defaultValue: '廉政举报' })
    "
    width="400px"
    @close="reportInfoVisible = false"
  >
    <div class="report-dialog">
      <div>
        <div>
          {{
            $getText("O_E_mail_report_it_S37e", {
              defaultValue: "举报邮箱：",
            }) + "mtmc.hg.dc@meituan.com"
          }}
        </div>
        <div>
          {{
            $getText("O_WeChat_report_it_FaDt", {
              defaultValue: "举报微信：",
            }) + "maicai_lianjie"
          }}
        </div>
      </div>
      <img class="report-image" src="../images/report-weixin.jpg" />
    </div>
  </mtd-modal>
</template>

<script>
export default {
  name: "ReportDialog",
  data() {
    return {
      reportInfoVisible: false,
    };
  },
  methods: {
    openDialog() {
      this.reportInfoVisible = true;
    },
  },
};
</script>

<style>
:root[dir="rtl"] .mtd-modal-title {
  margin-left: 30px;
  margin-right: auto;
}

:root[dir="rtl"] .mtd-modal-close {
  left: 24px;
  right: auto;
}
</style>

<style lang="scss" scoped>
.report-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.report-image {
  margin-top: 20px;
  width: 250px;
  height: auto;
}
</style>
